export function coerceStringRecord(value: unknown): Record<string, string> {
  if (!value || typeof value !== "object") {
    return {}
  }

  const entries = Object.entries(value as Record<string, unknown>).filter(
    ([, v]) => typeof v === "string" && v.trim().length > 0,
  )

  return entries.length > 0
    ? (Object.fromEntries(entries) as Record<string, string>)
    : {}
}
